module.exports = __webpack_public_path__ + "static/media/appstarter.383aeb5c.jpg";